import { Box, styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.primary.main,
  height: '18.75rem',
  borderRadius: '0.5rem',
  padding: '1.25rem',
  gap: '1rem',
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  justifyContent: 'flex-end',
  height: '100%',
}));

export const AlignedValue = styled('div')(() => ({
  width: '50%',
}));

export const RightAlignedValue = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  flex: 1,
  paddingRight: '8rem',
  textAlign: 'left',
}));


export const AlignStatusContainer = styled('div')(() => ({
  display: 'flex',
  height: '100%',
  gap: '1rem',
  alignItems: 'center',
}));

export const EditIconStyled = styled('img')(() => ({
  fontSize: '1.5rem',
}));

export const BoxCustom = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '.5rem',
  overflow: 'auto',
}));
